<template>
  <div
    class="modal fade"
    :id="modalId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="options && options.footer">
          <button type="button" class="btn btn-secondary" @click="closeWorklog">
            Zakljuci
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="save"
            :disabled="getTasks.length === 0"
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  props: {
    title: String,
    modalId: String,
    options: Object
  },
  computed: {
    getLoading() {
      return this.$store.getters.loading;
    },
    getTasks() {
      return this.$store.getters.getTasks;
    },
    getExecuteData() {
      return this.$store.getters.getExecuteData;
    },
    getMaterials() {
      return this.$store.getters.getMaterials;
    }
  },
  methods: {
    save() {
      this.getExecuteData.tasks = this.getTasks;
      this.getExecuteData.taskInProgress = true;
      this.getExecuteData.materials = this.getMaterials;
      this.$store.dispatch("saveChanges", this.getExecuteData);
      $("#" + this.modalId).modal("hide");
    },
    closeWorklog() {
      this.$emit("closeWorklog", true);
    }
  }
};
</script>
